const Portfolio_data = [
  {
    id: 1,
    category: "WORDPRESS",
    totalLike: "Project 1",
    title: "Client - London American City College, UAE",
    image: "images/lacc-image.png",
    desc: "The website lacc.ae, lacc.me, & londonamerican.university have been redesigned to be more user-friendly on all platforms. Online advertising Google Ads & Facebook campaigns are managed & generated quality leads.",
    desc2: "Created engaging content, posters, infographics, & reels for social media channels for Facebook, Instagram, LinkedIn, YouTube & Twitter to promote the college's brand.",
    skills: "Using keyword research, on-page, & off-page SEO strategies are optimized for the college's website to improve visibility & organic traffic on search engines.",
    link: "https://lacc.ae/",
  },
  {
    id: 2,
    category: "WORDPRESS",
    totalLike: "Project 2",
    title: "Client - Parenting.firstcry.com",
    image: "images/first.png",
    desc: "Developed an article blueprint for a Firstcry Parenting Website, offering expert guidance for parents.",
    desc2:"Created engaging and informative content across various parenting topics, including newborn essentials, baby development milestones, breastfeeding, sleep training, nutrition, and child safety.",
    skills: "Conducted keyword research(SEMrush) and implemented strategic SEO techniques to optimize content for search engine visibility. Skills Demonstrated: Content creation & strategy, SEO optimization, Meta tag implementation, Audience engagement, Parenting niche expertise, Content Management System (CMS), Google Analytics, and SEO plugins.",
    link: "https://parenting.firstcry.com/",
  },
  {
    id: 3,
    category: "WORDPRESS",
    totalLike: "Project 3",
    title: "Client - firstcry intelli",
    image: "images/first2n.png",
    desc: "Worked on the article blueprint for the FirstCry Intelli Education website, focusing on early childhood learning and parenting topics.",
    desc2: "Conducted keyword research and implemented strategic SEO techniques to optimize content for increasing search engine visibility.",
    skills: "Skills Demonstrated: Content creation & strategy, SEO optimization, Meta tag implementation, Parenting niche expertise, Content Management System (CMS), Google Analytics, and SEO plugins.",
    link: "https://www.firstcry.com/intelli/articles/",
  },
  {
    id: 4,
    category: "WORDPRESS",
    totalLike: "Project - 4",
    title: "Client - Cpimallikarjun.com",
    image: "images/mallikarjun-1.png",
    desc: "Created the UI design for the CPI Mallikarjun school website, focusing on creating an engaging and user-friendly interface for the school's online presence.",
    desc2: "Used best SEO techniques to increase visibility in search results.",
    skills: "Developed and managed social media content for CPImallikarjun.",
    link: "http://cpimallikarjun.in/",
  },
    {
      id: 5,
      category: "DEVELOPMENT",
      totalLike: "Project 5",
      title: "Client - Konfhub.com",
      image: "images/rectangle-42.png",
      desc: "Successfully designed and implemented a user-friendly and responsive UI for the Konfhub platform.",
      desc2: "Collaborated closely with cross-functional teams to understand user requirements and translate them into visually appealing design solutions.",
      skills: "Prototyping tools (Figma, Sketch), usability testing tools, responsive design frameworks.",
      link: "https://konfhub.com/",
    },

    {
      id: 6,
      category: "DEVELOPMENT",
      totalLike: "Project 6",
      title: "Client - Jcloud.com",
      image: "images/jcloud-day-1.png",
      desc: "Designed the UI/UX for the JCloud Day platform, a website that provides a means for organizers to advertise conferences online.",
      desc2: "Worked in groups to identify client requirements and converted requirements into eye-catching design solutions. ",
      skills: "Conducted thorough user research and usability testing, utilizing the insights to improve the JCloud Day platform's user interface for a user-friendly experience.",
      link: "https://jcloud.com",
    },
    
   
  ]
  export default Portfolio_data